module.exports = __webpack_public_path__ + "static/media/create-site-and-agent-step-2-es.dc8665c4.png";